import { Text, Box, VStack } from '@chakra-ui/react'
import Footer from '../components/Footer'
import NewsList from '../components/NewsList'

import { newsData } from '../data/data'
import { useTranslation } from 'react-i18next'

const NewsPage = () => {
  const { t } = useTranslation()

  return (
    <>

        <Box
            bg={'#f5f5f7'}
            width={'100%'}
            position="relative"
            padding={{ base: '12vh 5vw 8vh', md: '12vh 5vw 10vh' }}
             >
                <VStack
                    width={'100%'}
                    maxW={'1180px'}
                    margin={'auto'}
                  >
                    <Text
                        fontSize={{ base: '3xl', md: '4xl' }}
                        fontFamily={'heading'}
                        fontWeight={'bold'}
                        padding={'2vh 0'}
                        textAlign="center"
                        >{t('news.title')}</Text>
                        <Box width="100%" padding={{ base: '4vh 0', md: '6vh 0' }}>
                          <NewsList news={newsData}/>
                        </Box>

                </VStack>

        </Box>
        <Footer></Footer>

    </>
  )
}

export default NewsPage
